import { useNavigate } from "react-router-dom";
import INTOUCH_API from "../services/Api";
import useModalActions from "./useModalActions";
import { MODAL_TYPES } from "../utils/emitter";
import ROUTES from "../utils/routes";
import Game from "../store/Game";
import PersonalAccount from "../store/PersonalAccount";

// 07.10: анкета откровений создаётся ПАРОЙ — без партнёра в игре бэк отвечает 400
// (gameNotFound), а кнопки молча ничего не делали. Покупатель платил $5 за чистую
// анкету в игре без партнёра, и анкета «не появлялась». Теперь без партнёра сразу
// показываем «партнёр ещё не присоединился» со ссылкой-приглашением, а покупку не
// открываем. Купленное право не привязано к игре и сохраняется до создания анкеты.
export const findGame = (gameId) =>
  (PersonalAccount.games || []).find((g) => Number(g.id) === Number(gameId)) ||
  (Number(Game.game?.id) === Number(gameId) ? Game.game : null);

// true — партнёра нет, показали приглашение (вызывающему дальше не идти)
export const askToInvitePartner = (game, openModal) => {
  if (!game || game.invitedUserId) return false;
  if (Number(Game.game?.id) !== Number(game.id)) Game.setGame(game);
  openModal(MODAL_TYPES.LINK_WAS_NOT_SENT);
  return true;
};

// item 4: раньше «Чистая анкета» открывала попап CreateBlankFormModal с полем названия,
// и только потом саму анкету. Клиент попросил убрать попап — анкета открывается сразу, а
// тему юзер вводит первым блоком внутри формы (BlankTopicBlock уже умеет это и обновляет
// customTitle у обеих анкет пары). Здесь общая логика для всех точек входа:
// есть entitlement → создаём и уходим в форму; нет → попап покупки и повтор после оплаты.
export default function useCreateBlankForm() {
  const navigate = useNavigate();
  const { openModal } = useModalActions();

  const createAndOpen = (gameId) => {
    if (!gameId) return;
    INTOUCH_API.requestManager(
      "createInsightForm",
      { gameId, formType: "BLANK" },
      (response) => {
        navigate(ROUTES.INSIGHT_QUESTIONNAIRE_FORM_PAGE(response.data.id), {
          state: { formId: response.data.id },
        });
      },
      (error) => {
        const code = error?.response?.data?.message?.code;
        if (askToInvitePartner(findGame(gameId), openModal)) return;
        if (code === "BLANK_FORM_NOT_PURCHASED") {
          openModal(MODAL_TYPES.BUY_PRODUCT, {
            productType: "BLANK_FORM",
            gameId,
            onPurchased: () => createAndOpen(gameId),
          });
        }
      }
    );
  };

  // Единая точка входа: сама решает, нужна ли сначала покупка.
  const startBlankForm = (gameId, entitlements, from) => {
    // нет текущей игры — анкету не к чему привязать: в ЛК, где игры и приглашение
    if (!gameId) {
      navigate(ROUTES.PERSONAL_ACCOUNT_PAGE);
      return;
    }
    if (askToInvitePartner(findGame(gameId), openModal)) return;
    if (entitlements?.blankFormsAvailable > 0) {
      createAndOpen(gameId);
      return;
    }
    openModal(MODAL_TYPES.BUY_PRODUCT, {
      productType: "BLANK_FORM",
      gameId,
      ...(from ? { from } : {}),
      onPurchased: () => createAndOpen(gameId),
    });
  };

  return { startBlankForm, createAndOpen };
}
